import { License } from "../../api/models"

// Helpers shared by every license listing (Library, license detail, admin
// tables): the expiry formatting and the lock check read the same on all.

// expiresAt is derived server-side (trial record / entitlement) — a license
// either has a date or is perpetual; there is no "set on first activation"
// state any more.
export function formatExpiryDate(license: License) {
  if (license.expiresAt) {
    return new Date(license.expiresAt).toLocaleDateString()
  } else {
    return "Never"
  }
}

export function isLocked(license: License): boolean {
  return license.lockedUntil !== undefined && new Date(license.lockedUntil) > new Date()
}
